// Coach referral capture — pure, React-free so it can run at app startup
// (main.tsx) before React mounts and for LOGGED-OUT visitors.
//
// A coach's invite link (`https://trybeup.com/?coach=CODE`) is opened by
// brand-new people who then sign up. The authenticated app (MainApp) isn't
// mounted at that point, so a capture that only lived in a MainApp-mounted
// hook would miss it entirely and the referral (and the coach's rev-share)
// would be silently lost. Capturing at startup fixes that; the hook
// (useCoachReferralCapture) still does the post-auth binding.

export const COACH_REFERRAL_STORAGE_KEY = "trybeup_coach_ref";

/**
 * Reads `?coach=CODE` from the current URL and stashes it in localStorage so
 * it survives the logged-out → signup → authenticated round-trip. Idempotent
 * and safe to call anywhere, any number of times.
 */
export function captureCoachReferralFromUrl(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("coach");
    if (code && code.trim()) {
      localStorage.setItem(COACH_REFERRAL_STORAGE_KEY, code.trim().toUpperCase());
      // Clean the param out of the URL so it isn't re-processed / shared.
      params.delete("coach");
      const qs = params.toString();
      const newUrl = window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
      window.history.replaceState({}, "", newUrl);
    }
  } catch {
    /* ignore */
  }
}
